import { useTranslation } from "react-i18next"
import { Form } from "react-bootstrap"

interface ReauthenticationFormProps {
	password: string
	onPasswordChange: (password: string) => void
}

export default function ReauthenticationForm({ onPasswordChange, password }: ReauthenticationFormProps) {
	const { t } = useTranslation()

	return (
		<>
			<h2>{t("Vahvista salasanasi")}</h2>
			<p className="mt-2">{t("Vahvista salasanasi muuttaaksesi tätä asetusta.")}</p>
			<Form.Group className="mt-2" controlId="formBasicPassword">
				<Form.Label>{t("Salasana")}</Form.Label>
				<Form.Control type="password" value={password} onChange={(e) => onPasswordChange(e.target.value)} autoFocus />
			</Form.Group>
		</>
	)
}
